export const percentage = (numerator, denominator) =>
  Math.round(numerator / denominator * 100);

export const getRandomSplit = (variantWeight) => {
  const randomNumber = Math.random();
  const variantCeil = variantWeight ? 1 - variantWeight : 0.5;

  return randomNumber < variantCeil ? 0 : 1;
};

export const randomIntRange = (min, max, rng) =>
  Math.floor((rng || Math.random)() * (max - min + 1)) + min;

export const clamp = (value, { min = 0, max }) => Math.max(min, Math.min(value, max));
